@if (error() !== null) {
  <div class="errorBar mt-4">
    <div
      class="alert alert-danger alert-dismissible fade show error"
      role="alert">
      {{ error() }}
      <button
        type="button"
        class="btn-close btn-close-white"
        data-bs-dismiss="alert"
        aria-label="Dismiss"
        (click)="markAsHandled($event)"></button>
    </div>
  </div>
}

@if (message() !== null) {
  <div class="errorBar mt-4">
    <div
      class="alert alert-success alert-dismissible fade show"
      role="alert">
      {{ message() }}
      <button
        type="button"
        class="btn-close btn-close-white"
        data-bs-dismiss="alert"
        aria-label="Dismiss"
        (click)="markAsHandled($event)"></button>
    </div>
  </div>
}
